// DS: C35
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import EyeDisc2 from '../../Icons/16x16/EyeDisc2';
import PremiumFolderDisc from '../../Icons/PremiumFolderDisc';
import { IconSize } from '../../Icons/IconWrap';
import TextTooltipOnHover from '../../Popover/TextTooltipOnHover';
import { normalizePremiumFolderData } from '../../utils/normalizePremiumFolderData';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
var PremiumIndicator = function (_a) {
    var deviation = _a.deviation, className = _a.className;
    var t = useTranslation().t;
    var _b = normalizePremiumFolderData(deviation.premiumFolderData), isPremium = _b.isPremium, isPaidFolder = _b.isPaidFolder;
    // TODO: use in MobileSubmissionDetails when merging stats_on_the_right
    var isMobile = useContext(MobileContext);
    var isMobileLiterature = isMobile && getDeviationType(deviation) === DeviationTypes.LITERATURE;
    if (!isPremium || isMobileLiterature) {
        return null;
    }
    var indicator = isPaidFolder ? (React.createElement(PremiumFolderDisc, { size: IconSize.SMALL })) : (React.createElement(EyeDisc2, { size: IconSize.SMALL }));
    return isMobile ? (React.createElement("span", { className: className }, indicator)) : (React.createElement(TextTooltipOnHover, { className: className, tooltipText: isPaidFolder
            ? t('deviation.details.premiumFolder.tooltip')
            : t('deviation.details.watchersOnlyFolder.tooltip') }, indicator));
};
PremiumIndicator.displayName = 'PremiumIndicator';
export default PremiumIndicator;
//# sourceMappingURL=PremiumIndicator.js.map